import { ApiAuthError } from './errors'
import { message } from 'antd'
import { Toast } from 'antd-mobile'
import { isMobileBrowser } from 'utils/tools'
import { clearAllCookies } from '../index'

export const errorHandler = history => err => {
  isMobileBrowser() ? Toast.fail(err.message) : message.error(err.message)
  if (err instanceof ApiAuthError || err.code === '401') {
    console.log('服务端鉴权失败，清理session')
    clearAllCookies()
  }
}
